module.exports = __webpack_public_path__ + "static/media/bws3__.ee870ad9.svg";